import { PriorityStatusTooltip } from "@/components/priorities/PriorityStatusTooltip";
import { cn } from "@/lib/utils";
import { ListFilter } from "lucide-react";
import { statusOptions } from "./teamFilterConstants";

interface TeamPriorityFilterProps {
  value: string[];
  onToggle: (status: string) => void;
  onClear: () => void;
}

const chipBase =
  "inline-flex cursor-pointer items-center gap-1.5 rounded-full border px-3 py-1 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

/** Priority-status chips — these filter the CARDS inside each member's row. */
export const TeamPriorityFilter = ({ value, onToggle, onClear }: TeamPriorityFilterProps) => {
  const isAll = value.length === 0;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
      <span className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <ListFilter className="h-4 w-4" />
        Filter Status
      </span>
      <div className="flex flex-wrap items-center gap-1.5">
        <button
          type="button"
          aria-pressed={isAll}
          onClick={onClear}
          className={cn(
            chipBase,
            isAll
              ? "border-transparent bg-muted text-foreground ring-1 ring-border"
              : "border-border/60 text-muted-foreground hover:border-border hover:text-foreground",
          )}
        >
          All Status
        </button>
        {statusOptions.map((status) => {
          const isActive = value.includes(status.value);
          const Icon = status.icon;
          return (
            <PriorityStatusTooltip key={status.value} status={status.value}>
              <button
                type="button"
                aria-pressed={isActive}
                onClick={() => onToggle(status.value)}
                className={cn(
                  chipBase,
                  isActive
                    ? [status.activeClass, "border-transparent shadow-sm"]
                    : "border-border/60 text-muted-foreground hover:border-border hover:text-foreground",
                )}
              >
                <Icon className="h-3.5 w-3.5" />
                {status.label}
              </button>
            </PriorityStatusTooltip>
          );
        })}
      </div>
    </div>
  );
};
